import { configureStore } from '@reduxjs/toolkit';
import { fundCentreSlice } from './fundCentre/slice';
import { fundCentreApi } from './fundCentre/services/fundCentreAPI';
import { apiSlice as kidshubApi } from './kidshub';
import { globalSlice } from '@/store/global';
import { fundDetailsSlice } from './fundDetails/slice';
import { fundDetailsApi } from './fundDetails/services/fundDetailsApi';
import { articlesSlice } from './articles';
import { articleApi } from '@/store/articles/services/articleAPI';
import { articleSearch } from '@/store/articles/services/articleSearch';
import { literatureHubApi } from '@/store/literatureHub/services/literatureHubAPI';
import { documentListingAPI } from '@/store/documentListing/services/documentListingAPI';
import { salesforceApi } from './salesforce/services/salesforceApi';

export const store = configureStore({
  reducer: {
    fundCentre: fundCentreSlice.reducer,
    fundDetails: fundDetailsSlice.reducer,
    [fundCentreApi.reducerPath]: fundCentreApi.reducer,
    [kidshubApi.reducerPath]: kidshubApi.reducer,
    [documentListingAPI.reducerPath]: documentListingAPI.reducer,
    [fundDetailsApi.reducerPath]: fundDetailsApi.reducer,
    global: globalSlice.reducer,
    articles: articlesSlice.reducer,
    [articlesSlice.reducerPath]: articlesSlice.reducer,
    [articleApi.reducerPath]: articleApi.reducer,
    [articleSearch.reducerPath]: articleSearch.reducer,
    [literatureHubApi.reducerPath]: literatureHubApi.reducer,
    [salesforceApi.reducerPath]: salesforceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(fundCentreApi.middleware)
      .concat(kidshubApi.middleware)
      .concat(fundDetailsApi.middleware)
      .concat(documentListingAPI.middleware)
      .concat(articleSearch.middleware)
      .concat(articleApi.middleware)
      .concat(literatureHubApi.middleware)
      .concat(salesforceApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
